module.exports = __webpack_public_path__ + "static/media/img04.90aad2dc.png";